// src/v2/pages/Reports/BIR0619E.js
import React from 'react';
import { GeneralMessage } from '../../../common/APICommon';
import { BIR0619EModule } from '../../components/modules/Reports/BIR0619E/BIR0619EModule';
import { useBIR0619E } from '../../hooks/useBIR0619E';

/**
 * BIR0619E Page Component
 * Following V2 Architecture: Entry point that connects the Logic (Hook) to the UI (Module)
 */
const BIR0619E = ({ isHideSideMenu }) => {
  const reportHook = useBIR0619E();

  return (
    <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
      <div className="LeftSpace"></div>
      
      <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
        {/* The Module contains the actual filters and table preview */}
        <BIR0619EModule reportHook={reportHook} />
      </div>

      {/* Global Message handling for Success/Error feedback */}
      <GeneralMessage
        form={reportHook.showMessage}
        message={reportHook.message}
        isSuccess={reportHook.isSuccess}
      />
    </div>
  );
};

export default BIR0619E;